import React, { useMemo, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import CourseList from './components/CourseList';
import CourseDetail from './components/CourseDetail';
import courses from './data/courses';

function HomePage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [category, setCategory] = useState('all');

  const filteredCourses = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    return courses.filter((course) => {
      const matchesSearch =
        !term ||
        course.name.toLowerCase().includes(term) ||
        course.category.toLowerCase().includes(term) ||
        course.domain.toLowerCase().includes(term);

      const matchesCategory = category === 'all' || course.category === category;

      return matchesSearch && matchesCategory;
    });
  }, [searchTerm, category]);

  return (
    <main className="cf-main">
      <section className="cf-controls">
        <SearchBar
          value={searchTerm}
          onChange={setSearchTerm}
          category={category}
          onCategoryChange={setCategory}
        />
      </section>
      <section className="cf-results">
        <div className="cf-results-header">
          <h2 className="cf-section-title">Available Courses</h2>
          <p className="cf-result-count">
            Showing <strong>{filteredCourses.length}</strong> of{' '}
            <strong>{courses.length}</strong> courses
          </p>
        </div>
        <CourseList courses={filteredCourses} />
      </section>
    </main>
  );
}

function App() {
  const location = useLocation();
  const isDetailPage = location.pathname.startsWith('/courses/');

  return (
    <div className="cf-app">
      <Header />
      {isDetailPage ? (
        <Routes>
          <Route path="/courses/:id" element={<CourseDetail />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      )}
      <footer className="cf-footer">
        <p>Course Finder · Crafted by Amul Agarwal</p>
      </footer>
    </div>
  );
}

export default App;
